



























































































import { Component, Prop, Vue, Inject, Watch } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Search, SortDirection } from '@/data/models/search.model';
import { PeriodicService } from '@/data/models/periodicservice.model';
import { ServiceInstance, ServiceInstanceTotals } from '@/data/models/serviceinstance.model';
import { PeriodicEntityService } from '@/data/services/periodic.service';

@Component
export default class ServizioPeriodicoServiziTable extends Vue {
	@Prop() periodicservice!: PeriodicService;
	
	@Inject('CrudService') crudService!: CrudService<ServiceInstance>;
	@Inject('PeriodicEntityService') periodicentityService!: PeriodicEntityService;

	rows: ServiceInstance[] = [];
	totals!: ServiceInstanceTotals;
	loading: boolean = false;

	advancedSearch: Search = new Search('serviceinstance');

	constructor() {
		super();
		this.totals = new ServiceInstanceTotals();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	@Watch('periodicservice')
	onPeriodicserviceChange() {
		this.load();
	}

	created() {
		if (this.periodicservice) {
			this.advancedSearch.addSimpleFilter('periodicserviceid', this.periodicservice.id!);
			this.load();
		}
	}

	load() {

		const datareq = this.crudService.searchEntities(
			ServiceInstance,
			'serviceinstance',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			ServiceInstance,
			'serviceinstance',
			this.advancedSearch
		);

		const requests: any[] = [datareq, countreq];

		if (this.periodicservice.id && this.periodicservice.hasPeriodicItems) {
			const amountreq = this.periodicentityService.periodicServiceTotals(this.periodicservice.id!);
			requests.push(amountreq);
		}

		this.loading = true;
		Promise.all(requests)
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
				if (this.periodicservice.id && this.periodicservice.hasPeriodicItems) this.totals = results[2];
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.load();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.load();
	}

}
